export default () => {
    return <div>Analysis!!!</div>
}
